import { render, staticRenderFns } from "./DoctorSchedule.vue?vue&type=template&id=704f922c&scoped=true"
import script from "./DoctorSchedule.vue?vue&type=script&lang=js"
export * from "./DoctorSchedule.vue?vue&type=script&lang=js"
import style0 from "./DoctorSchedule.vue?vue&type=style&index=0&id=704f922c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f922c",
  null
  
)

export default component.exports